import { v4 as uuid } from 'uuid';

export function readAsDataURL(file: File) {
  return new Promise((resolve, reject) => {
    let fileReader = new FileReader();
    fileReader.onload = function () {
      return resolve({
        id: uuid(),
        data: fileReader.result?.toString()?.substring(fileReader.result?.toString()?.indexOf('base64,') + 7),
        name: file.name,
        size: file.size,
        type: file.type,
        preview: fileReader.result,
      });
    };
    fileReader.readAsDataURL(file);
  });
}

export const getBase64Image = (url: string) => {
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx?.drawImage(img, 0, 0);
    canvas?.toDataURL('image/png');
  };
  img.src = url;
};
